import cart from '../../api/cart'
import EventBus from '../../event-bus'
import { assign, pick } from 'lodash-es'

const state = {
    items: [],
    discounts: [],
    price: {
        net: 0,
        gross: 0,
        vatValue: 0,
        vatPercentage: 0
    },
    shippable: false
}

const getters = {
    count(state) {
        return state.items.reduce((carry, item) => carry + item.quantity, 0)
    },

    hasUnshippableItems(state) {
        return state.items.filter(item => ! item.shippable)
            .length > 0
    },

    getProductById: (state) => (id) => {
        return state.items.find(
            item => item.id.identifier === id.identifier
                    && item.id.type === id.type
        )
    }
}

const actions = {
    async load({ commit }) {
        try {
            const response = await cart.getItems()

            commit('update', response.data.cart)
            EventBus.$emit('cart-loaded')
        } catch (error) {
            EventBus.$emit('cart-error', error)
        }
    },

    async add( { getters, commit }, { id, quantity } ) {
        try {
            const response = await cart.add(id, quantity)

            commit('update', response.data.cart)
            EventBus.$emit('cart-item-added', getters.getProductById(id))
            EventBus.$emit('cart-modified', response.data.cart)

            reportDiscountChanges(response.data)
        } catch (error) {
            EventBus.$emit('cart-error', error)
        }
    },

    async update({ getters, commit }, { id, quantity }) {
        try {
            const response = await cart.update(id, quantity)

            commit('update', response.data.cart)
            EventBus.$emit('cart-item-updated', getters.getProductById(id))
            EventBus.$emit('cart-modified', response.data.cart)

            reportDiscountChanges(response.data)
        } catch (error) {
            EventBus.$emit('cart-error', error)
        }
    },

    async remove({ getters, commit }, id) {
        try {
            const removedItem = getters.getProductById(id)
            const response = await cart.remove(id)

            commit('update', response.data.cart)
            EventBus.$emit('cart-item-removed', removedItem)
            EventBus.$emit('cart-modified', response.data.cart)

            reportDiscountChanges(response.data)
        } catch (error) {
            EventBus.$emit('cart-error', error)
        }
    },

    async redeemCoupon({ commit }, code) {
        try {
            const response = await cart.redeemCoupon(code)

            commit('update', response.data.cart)
            EventBus.$emit('coupon-redeemed', code)
            EventBus.$emit('cart-modified', response.data.cart)

            reportDiscountChanges(response.data)
        } catch (error) {
            EventBus.$emit('coupon-redeem-error', error)
        }
    },

    async removeCoupon({ commit }, code) {
        try {
            const response = await cart.removeCoupon(code)

            commit('update', response.data.cart)
            EventBus.$emit('coupon-removed', code)
            EventBus.$emit('cart-modified', response.data.cart)
        } catch (error) {
            EventBus.$emit('coupon-remove-error', error)
        }
    }
}

const mutations = {
    update(state, cart) {
        assign(state, pick(cart, ['items', 'discounts', 'price', 'shippable']))
    },
}

function reportDiscountChanges(data) {
    if (Object.prototype.hasOwnProperty.call(data, 'changes') && data.changes.length > 0) {
        EventBus.$emit('cart-discounts-changed', data.changes)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
